export default __webpack_public_path__ + "static/media/grid.24e6d097.svg";